<div class="main-content">
  <h2>Search Bid Rounds</h2>
  <form [formGroup]="searchForm" (ngSubmit)="onSearch()">
    <div class="form-row">
      <div class="form-group">
        <label for="bid_status" class="form-label">Bid Status:</label>
        <select id="bid_status" formControlName="bid_status" class="form-control">
          <option *ngFor="let status of bidStatusOptions" [value]="status">{{ status }}</option>
        </select>
      </div>
    </div>
    <button type="submit" class="submit-button">Search</button>
    
  </form>

  <button  *ngIf="!showForm" class="new-button" (click)="onNew()">New</button>
  
  <table *ngIf="!showForm" class="table table-striped">
    <thead>
      <tr>
        <th>Start Time</th>
        <th>End Time</th>
        <th>Bid Type</th>
        <th>Start Trade Period</th>
        <th>End Trade Period</th>
        <th>Status</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let bidRound of bidRounds">
        <td>{{ bidRound.start_time }}</td>
        <td>{{ bidRound.end_time }}</td>
        <td>{{ bidRound.bid_type }}</td>
        <td>{{ bidRound.start_trade_period }}</td>
        <td>{{ bidRound.end_trade_period }}</td>
        <td>{{ bidRound.status }}</td>
        <td>
          <button (click)="onEdit(bidRound)" class="btn btn-primary">Edit</button>
          <button (click)="onDelete(bidRound.id)" class="btn btn-danger">X</button>
        </td>
      </tr>
    </tbody>
  </table>

  <div *ngIf="showForm" class="form-section">
    <h2>{{ isEdit ? 'Update Bid Round' : 'Create Bid Round' }}</h2>
    <form [formGroup]="bidRoundForm" (ngSubmit)="onSubmit()">
      <div class="form-row">
        <div class="form-column">
          <div class="form-group">
            <label for="start_time" class="form-label">Start Time:</label>
            <input type="datetime-local" id="start_time" formControlName="start_time" class="form-control" [min]="minDate" />
          </div>
          <div class="form-group">
            <label for="end_time" class="form-label">End Time:</label>
            <input type="datetime-local" id="end_time" formControlName="end_time" class="form-control" [min]="bidRoundForm.value.start_time" />
          </div>
        </div>
        <div class="form-column">
          <div class="form-group">
            <label for="start_trade_period" class="form-label">Start Trade Period:</label>
            <input type="datetime-local" id="start_trade_period" formControlName="start_trade_period" class="form-control" [min]="bidRoundForm.value.end_time" />
          </div>
          <div class="form-group">
            <label for="end_trade_period" class="form-label">End Trade Period:</label>
            <input type="datetime-local" id="end_trade_period" formControlName="end_trade_period" class="form-control" [min]="bidRoundForm.value.start_trade_period" />
          </div>
          <div class="form-group">
            <label for="bid_type" class="form-label">Bid Type:</label>
            <select id="bid_type" formControlName="bid_type" class="form-control">
              <option *ngFor="let type of bidTypeOptions" [value]="type">{{ type }}</option>
            </select>
          </div>
          <div class="form-group" *ngIf="isEdit">
            <label for="bid_status" class="form-label">Status:</label>
            <select id="bid_status" formControlName="status" class="form-control">
              <option *ngFor="let status of bidStatusOptions" [value]="status">{{ status }}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="action-buttons">
        <button type="button" class="cancel-button" (click)="onCancel()">Cancel</button>
        <button type="submit" class="submit-button">{{ isEdit ? 'Update' : 'Create' }}</button>
        
      </div>
    </form>

    <div *ngIf="errorMessage" class="error-message">{{ errorMessage }}</div>
  </div>

</div>
